import React from 'react';
import { Clock, Target, Repeat, Brain } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Clock,
  title: 'Time Management',
  description: 'Practical frameworks for structuring your day, week, and deep work sessions.'
}, {
  icon: Target,
  title: 'Focus Techniques',
  description: 'Science-backed methods to sustain attention and eliminate distractions.'
}, {
  icon: Repeat,
  title: 'Habit Formation',
  description: 'Build systems that stick. From morning routines to evening wind-downs.'
}, {
  icon: Brain,
  title: 'Attention Optimization',
  description: 'Understand how your mind works and use it to your advantage.'
}];
export function ValueProps() {
  return <section className="py-20 bg-brand-navy text-white relative overflow-hidden" data-id="element-212">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#527CBC 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-213"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-216">
            What You'll Get Every Sunday
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-217">
            No fluff. Just actionable systems to help you do your best work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-218">
          {features.map((feature, index) => <motion.div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-219">
              <div className="w-12 h-12 bg-brand-gold/20 rounded-lg flex items-center justify-center text-brand-gold mb-6" data-id="element-220">
                <feature.icon size={24} data-id="element-221" />
              </div>
              <h3 className="text-xl font-serif font-bold text-white mb-3" data-id="element-222">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-223">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}